import axios from "axios";

export default function EntrylocationDownloadByNetworkIdReportService(networkId) {
  return axios.get(process.env.REACT_APP_API_HOST + "/entry_location/" + networkId + "/report/byNetwork", {
    responseType: 'blob',
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
};
